import axios from "axios";
import config from "../config";

const api = axios.create({
	baseURL: config.API_ROOT,
	timeout: 60000,
	headers: {
		Accept: "application/json",
		"Cache-Control": "no-cache",
		"Content-Type": "application/json",
		"B1S-CaseInsensitive": true,
	},

	transformResponse: (data) => {
		// console.log("fetch response", data);
		return data;
	},
	withCredentials: true,
});

api.interceptors.request.use((request) => {
	const token = localStorage.getItem("token");

	if (token) {
		request.headers = {
			...request.headers,
			[config.backendTokenKEY]: `Bearer ${token}`,
		};
	}

	return request;
});

api.interceptors.response.use(
	(response) => {
		// success response
		return response;
	},
	(error) => {
		console.log("error in interceptor", error);

		if (error.response && error.response.status === 401) {
			window.location.pathname = "/login";
		}

		return Promise.reject(error);
	}
);

export default api;
